var map = {
	"./AchIcon.tsx": "o7wl",
	"./ActivityFeedIcon.tsx": "ZiMM",
	"./AddIcon.tsx": "WGrf",
	"./AdvancedFiltersIcon.tsx": "MJPk",
	"./AggregateDataSetFieldIcon.tsx": "9tLO",
	"./AiMessageIcon.tsx": "2DTN",
	"./AlignCenterIcon.tsx": "0OXm",
	"./AlignJustifyIcon.tsx": "PH6w",
	"./AlignLeftIcon.tsx": "hChu",
	"./AlignRightIcon.tsx": "oiRC",
	"./AnchorIcon.tsx": "jygQ",
	"./AppointmentIcon.tsx": "maRA",
	"./ApprovalsAltIcon.tsx": "h5mB",
	"./ApprovalsIcon.tsx": "3UQG",
	"./ApproveDraftIcon.tsx": "VL+D",
	"./ArchiveIcon.tsx": "qLgk",
	"./ArtificialIntelligenceEnhancedIcon.tsx": "BJ2l",
	"./ArtificialIntelligenceIcon.tsx": "rAre",
	"./AttachIcon.tsx": "RJbi",
	"./AudienceTargetingIcon.tsx": "cJtU",
	"./AudioFileIcon.tsx": "21D2",
	"./AudioInputOutputIcon.tsx": "tBTS",
	"./AutomationsIcon.tsx": "asAY",
	"./BackgroundColorIcon.tsx": "EQEt",
	"./BankIcon.tsx": "W3hJ",
	"./BlankIcon.tsx": "3soz",
	"./BlockAlignmentBottomIcon.tsx": "JPMK",
	"./BlockAlignmentCenterIcon.tsx": "LOkG",
	"./BlockAlignmentLeftIcon.tsx": "8VyB",
	"./BlockAlignmentMiddleIcon.tsx": "L3wi",
	"./BlockAlignmentRightIcon.tsx": "aeZD",
	"./BlockAlignmentTopIcon.tsx": "7QBy",
	"./BlockIcon.tsx": "WGkS",
	"./BlogIcon.tsx": "jaCf",
	"./BoardViewIcon.tsx": "SQhO",
	"./BoldIcon.tsx": "2hpF",
	"./BookIcon.tsx": "tjBt",
	"./BookmarkIcon.tsx": "cWTv",
	"./BooleanDataTypeIcon.tsx": "EQgk",
	"./BoxIcon.tsx": "DW9d",
	"./BreezeRegenerateIcon.tsx": "Sk1Y",
	"./BreezeSendIcon.tsx": "VtOL",
	"./BreezeSingleStarIcon.tsx": "w42b",
	"./BubbleIcon.tsx": "J4GU",
	"./BulbIcon.tsx": "roM/",
	"./BulletCircleIcon.tsx": "aoRC",
	"./BulletDiamondIcon.tsx": "1UXh",
	"./BulletListIcon.tsx": "ZPz7",
	"./BulletLowerAlphaIcon.tsx": "RpVO",
	"./BulletLowerGreekIcon.tsx": "PID/",
	"./BulletLowerRomanIcon.tsx": "Z8JD",
	"./BulletSquareIcon.tsx": "kHN9",
	"./BulletUpperAlphaIcon.tsx": "b4LN",
	"./BulletUpperRomanIcon.tsx": "sJmQ",
	"./CRMDevelopmentIcon.tsx": "Fnu8",
	"./CallIcon.tsx": "bdvD",
	"./CallIncomingIcon.tsx": "RL2P",
	"./CallOutgoingIcon.tsx": "5+rd",
	"./CallTranscriptIcon.tsx": "qo6+",
	"./CallingHangupIcon.tsx": "dhGy",
	"./CallingIcon.tsx": "eLOR",
	"./CallingMadeIcon.tsx": "iZta",
	"./CallingMissedIcon.tsx": "LfSa",
	"./CallingVoicemailIcon.tsx": "NEPq",
	"./CampaignsIcon.tsx": "55ph",
	"./CapIcon.tsx": "7jgb",
	"./CardIcon.tsx": "hPAh",
	"./CartIcon.tsx": "buoA",
	"./CaseIcon.tsx": "Jl/r",
	"./CaseStudyIcon.tsx": "I1R7",
	"./CertificationIcon.tsx": "XAJn",
	"./ChatspotIcon.tsx": "irVd",
	"./CheckCircleIcon.tsx": "Vo0l",
	"./CheckboxCheckedIcon.tsx": "GjLu",
	"./CheckboxIcon.tsx": "7GOO",
	"./CheckboxIndeterminateIcon.tsx": "gRFw",
	"./ChecklistIcon.tsx": "autS",
	"./ChevronsOutwardIcon.tsx": "a+X2",
	"./CircleFilledIcon.tsx": "A8+u",
	"./CircleHollowIcon.tsx": "8iw+",
	"./ClipboardIcon.tsx": "GNmB",
	"./ClosedCaptionsIcon.tsx": "H5zb",
	"./CoachingPlaylistIcon.tsx": "K3l2",
	"./CodeIcon.tsx": "ediE",
	"./CogIcon.tsx": "Udlf",
	"./ColumnIcon.tsx": "954j",
	"./CommentsIcon.tsx": "P9kH",
	"./CommerceIcon.tsx": "xmW1",
	"./CommunicationIcon.tsx": "Wbyn",
	"./CompaniesIcon.tsx": "848k",
	"./ConditionalFormulaDataSetFieldIcon.tsx": "Sr+u",
	"./ConditionalIcon.tsx": "7sGJ",
	"./ContactCheckIcon.tsx": "n3Px",
	"./ContactDuplicateIcon.tsx": "GB6M",
	"./ContactPropertiesIcon.tsx": "Jp3o",
	"./ContactsIcon.tsx": "VR7a",
	"./ContentIcon.tsx": "bEjK",
	"./ContractsIcon.tsx": "3Ayu",
	"./ControlPanelIcon.tsx": "JRQJ",
	"./CopyIcon.tsx": "NdDd",
	"./CourseIcon.tsx": "EODP",
	"./CreditCardIcon.tsx": "GysV",
	"./CreditsIcon.tsx": "lGLe",
	"./CrmIcon.tsx": "I2Uu",
	"./CropIcon.tsx": "vCEx",
	"./CrossSellIcon.tsx": "YqFD",
	"./CssFileIcon.tsx": "oHZm",
	"./CtasIcon.tsx": "zMH7",
	"./CustomHublIcon.tsx": "ORnf",
	"./CustomModulesIcon.tsx": "RryA",
	"./CustomObjectIcon.tsx": "QKwL",
	"./DarkIcon.tsx": "l2Lj",
	"./DashboardsIcon.tsx": "txoI",
	"./DataAgentIcon.tsx": "nwjK",
	"./DataManagementIcon.tsx": "dMji",
	"./DataQualityIcon.tsx": "SKNR",
	"./DataSyncIcon.tsx": "B/Zc",
	"./DataSyncLeftIcon.tsx": "/N9Z",
	"./DataSyncRightIcon.tsx": "AGt+",
	"./DatabasesIcon.tsx": "rEYq",
	"./DateCloseIcon.tsx": "vfFf",
	"./DateDataTypeIcon.tsx": "x2gS",
	"./DateIcon.tsx": "0bhr",
	"./DateOpenIcon.tsx": "l8Wi",
	"./DealsIcon.tsx": "S2VZ",
	"./DebugIcon.tsx": "Bisk",
	"./DelayIcon.tsx": "emtF",
	"./DeleteIcon.tsx": "PXsC",
	"./DescriptionIcon.tsx": "YSMv",
	"./DesktopIcon.tsx": "vNUn",
	"./DeveloperProjectsIcon.tsx": "cJEG",
	"./DiamondIcon.tsx": "+9sj",
	"./DiffIcon.tsx": "Wx//",
	"./DividerIcon.tsx": "nB0h",
	"./DocumentsIcon.tsx": "fwOh",
	"./DownCaratIcon.tsx": "wI9A",
	"./DownIcon.tsx": "EveO",
	"./DownloadIcon.tsx": "eZ8Q",
	"./DownvoteFilledIcon.tsx": "gcuP",
	"./DownvoteIcon.tsx": "RSei",
	"./DragAndDropLayoutIcon.tsx": "3vFH",
	"./DragHandleIcon.tsx": "iG55",
	"./DropboxIcon.tsx": "FIdR",
	"./DropdownIcon.tsx": "SW1w",
	"./DuplicateIcon.tsx": "CmIX",
	"./DynamicFilterIcon.tsx": "xIKP",
	"./EditColumnsIcon.tsx": "5OOJ",
	"./EditIcon.tsx": "aFCx",
	"./EllipsesIcon.tsx": "cd3a",
	"./EmailIcon.tsx": "eJki",
	"./EmailOpenIcon.tsx": "IgnQ",
	"./EmailThreadedRepliesIcon.tsx": "YlYP",
	"./EmbedIcon.tsx": "9c8i",
	"./EmojiFillHappyIcon.tsx": "tyEv",
	"./EmojiFillNeutralIcon.tsx": "CyRo",
	"./EmojiFillSadIcon.tsx": "SPiZ",
	"./EmojiIcon.tsx": "oXEb",
	"./EmojiLineNeutralIcon.tsx": "A9ZQ",
	"./EmojiLineSadIcon.tsx": "qga/",
	"./EnlargeIcon.tsx": "Cgcm",
	"./EnrichmentIcon.tsx": "3tPZ",
	"./EnrollIcon.tsx": "8rUb",
	"./EnumerationDataTypeIcon.tsx": "Mjsy",
	"./EraseStylesIcon.tsx": "uOJv",
	"./ExcelFileIcon.tsx": "ySfZ",
	"./ExclamationCircleIcon.tsx": "+bLU",
	"./ExclamationIcon.tsx": "+JJk",
	"./ExitFullScreenIcon.tsx": "CRH1",
	"./ExpandIcon.tsx": "jkA1",
	"./ExternalLinkIcon.tsx": "VoGK",
	"./FavoriteHollowIcon.tsx": "1x/6",
	"./FavoriteIcon.tsx": "Gl4H",
	"./FeedbackSurveysIcon.tsx": "4tzM",
	"./FileIcon.tsx": "0Wf9",
	"./FilledDownIcon.tsx": "3Wgf",
	"./FilledUpAndDownIcon.tsx": "lSAW",
	"./FilledXCircleIconIcon.tsx": "Lq3q",
	"./FilterIcon.tsx": "o/dW",
	"./FirstIcon.tsx": "LDHH",
	"./FixedLayoutIcon.tsx": "bjI0",
	"./FlexColumnIcon.tsx": "DiCV",
	"./FoldedPaperIcon.tsx": "tqOk",
	"./FolderIcon.tsx": "DhLX",
	"./FolderOpenIcon.tsx": "CvhI",
	"./FolderServerlessFunctionIcon.tsx": "gvTb",
	"./FolderServerlessFunctionOpenIcon.tsx": "5iUb",
	"./FolderThemeIcon.tsx": "mql/",
	"./FolderThemeOpenIcon.tsx": "9lMA",
	"./FontFileIcon.tsx": "HLLS",
	"./FooterIcon.tsx": "P7Ur",
	"./FormsIcon.tsx": "AJ3s",
	"./FormulaDataSetFieldIcon.tsx": "ogQ4",
	"./ForwardIcon.tsx": "d62Y",
	"./FullWidthIcon.tsx": "/wW6",
	"./GanttViewIcon.tsx": "YzMq",
	"./GapHorizontalIcon.tsx": "Heow",
	"./GapVerticalIcon.tsx": "DcQB",
	"./GaugeIcon.tsx": "Wfx/",
	"./GddcIcon.tsx": "OSac",
	"./GenerateChartIcon.tsx": "rWHE",
	"./GhostIcon.tsx": "e1Z1",
	"./GiftIcon.tsx": "EnW+",
	"./GithubBranchIcon.tsx": "ihL2",
	"./GithubCommitIcon.tsx": "UTQf",
	"./GithubIcon.tsx": "LvR+",
	"./GithubRepositoryIcon.tsx": "pWBf",
	"./GlobalGroupIcon.tsx": "C8nn",
	"./GlobeIcon.tsx": "qbQR",
	"./GoalIcon.tsx": "S6kv",
	"./GraphqlFileIcon.tsx": "iliJ",
	"./GridIcon.tsx": "ydw7",
	"./GroupModuleIcon.tsx": "VKMn",
	"./GuidedActionsIcon.tsx": "Gj4X",
	"./H1Icon.tsx": "lS8w",
	"./H2Icon.tsx": "SU3U",
	"./H3Icon.tsx": "9+ZV",
	"./H4Icon.tsx": "ARzt",
	"./H5Icon.tsx": "ZNv6",
	"./HamburgerMenuIcon.tsx": "D3ba",
	"./HeaderIcon.tsx": "+BJK",
	"./HelpDeskIcon.tsx": "+YeK",
	"./HideIcon.tsx": "hkBl",
	"./HighlightIcon.tsx": "2aVN",
	"./HighlyEngagedLeadIcon.tsx": "Uu1I",
	"./HomeIcon.tsx": "lbiB",
	"./HorizontalRuleIcon.tsx": "GsNt",
	"./HsDesignCertIcon.tsx": "Wiw2",
	"./HtmlFileIcon.tsx": "aFEs",
	"./HubDBIcon.tsx": "xdx2",
	"./HubspotCertificationIcon.tsx": "q23z",
	"./ImageAlignmentLeftIcon.tsx": "jIrD",
	"./ImageAlignmentMiddleIcon.tsx": "OQdI",
	"./ImageAlignmentRightIcon.tsx": "vctL",
	"./ImageAlignmentTopIcon.tsx": "lErx",
	"./ImageGalleryIcon.tsx": "01sg",
	"./InboxIcon.tsx": "2dz5",
	"./IndentIcon.tsx": "L1iI",
	"./InfoCircleIcon.tsx": "Mrxc",
	"./InfoIcon.tsx": "ekdb",
	"./InfoNoCircleIcon.tsx": "Wg3+",
	"./InlineIcon.tsx": "0TsD",
	"./InsertImageIcon.tsx": "5D+e",
	"./InsertQuoteIcon.tsx": "FW8C",
	"./InsertVideoIcon.tsx": "YzAl",
	"./IntegrationsIcon.tsx": "GId7",
	"./IntegrationsSalesForceIcon.tsx": "7UjX",
	"./IntegrationsSurveyMonkeyIcon.tsx": "Y1eD",
	"./InvoiceIcon.tsx": "TJ6H",
	"./ItalicIcon.tsx": "LJ28",
	"./JsFileIcon.tsx": "ErjP",
	"./JsonFileIcon.tsx": "rbY6",
	"./KanbanIcon.tsx": "xUoI",
	"./KeyIcon.tsx": "/tgq",
	"./KnowledgeBaseIcon.tsx": "LQkm",
	"./LanguageIcon.tsx": "aCvw",
	"./LastIcon.tsx": "q7C9",
	"./LayersIcon.tsx": "tuDw",
	"./LeadScoringIcon.tsx": "vCKX",
	"./LeftIcon.tsx": "JlOG",
	"./LessCircleIcon.tsx": "MXh9",
	"./LessonIcon.tsx": "eEbY",
	"./LibraryIcon.tsx": "CFMC",
	"./LightIcon.tsx": "eLgd",
	"./LineHeightIcon.tsx": "yV7b",
	"./LineItemsIcon.tsx": "9kaY",
	"./LinkIcon.tsx": "UNYP",
	"./ListViewIcon.tsx": "DPbF",
	"./ListsIcon.tsx": "P7Vu",
	"./LocationIcon.tsx": "FmiM",
	"./LockedIcon.tsx": "RwMb",
	"./LogCallIcon.tsx": "kxiQ",
	"./LogEmailIcon.tsx": "MxSs",
	"./LogLinkedInMessageIcon.tsx": "+q4+",
	"./LogMeetingIcon.tsx": "HFbF",
	"./LogPostalMailIcon.tsx": "TGIg",
	"./LogSMSIcon.tsx": "yoFB",
	"./LogWhatsAppMessageIcon.tsx": "vh4N",
	"./LogoDescriptIcon.tsx": "dsev",
	"./LogoHeyGenIcon.tsx": "sjmz",
	"./LogoIcon.tsx": "HbOu",
	"./LogoMCPIcon.tsx": "aoA/",
	"./LogoThreadsIcon.tsx": "KG3h",
	"./LogoZoomIcon.tsx": "5Y//",
	"./LogoutIcon.tsx": "FwYW",
	"./MakeDraftIcon.tsx": "Nk+1",
	"./MapIcon.tsx": "y17G",
	"./MarkdownFileIcon.tsx": "F57Q",
	"./MarketingEventsIcon.tsx": "Gkp0",
	"./MarketingIcon.tsx": "+Fa+",
	"./MarketplaceIcon.tsx": "75tW",
	"./MeetingEventIcon.tsx": "dOHJ",
	"./MeetingsIcon.tsx": "uFLX",
	"./MentionIcon.tsx": "3pVg",
	"./MenuIcon.tsx": "jVLK",
	"./MergeIcon.tsx": "rocw",
	"./MessagesIcon.tsx": "4Afa",
	"./MinusIcon.tsx": "uNsS",
	"./MobileIcon.tsx": "Nhe1",
	"./MoreCircleIcon.tsx": "c5nh",
	"./MoveIcon.tsx": "bVZM",
	"./NextIcon.tsx": "oaFY",
	"./NonbreakingSpaceIcon.tsx": "96cc",
	"./NotEditableIcon.tsx": "NN7Q",
	"./NotUsingCreditsIcon.tsx": "yW04",
	"./NotificationIcon.tsx": "SX3P",
	"./NotificationOffIcon.tsx": "6g5H",
	"./NotificationPopupIcon.tsx": "rS0F",
	"./NumberListIcon.tsx": "TJjU",
	"./NumericDataTypeIcon.tsx": "aK6/",
	"./ObjectAssociationsIcon.tsx": "JyVY",
	"./ObjectAssociationsManyToManyIcon.tsx": "LIyn",
	"./ObjectAssociationsManyToOneIcon.tsx": "PcR4",
	"./Office365Icon.tsx": "ZvCa",
	"./OnlineRegistrationIcon.tsx": "6VHf",
	"./OrderIcon.tsx": "kisA",
	"./OutdentIcon.tsx": "2t5x",
	"./PaddingBottomIcon.tsx": "ERSX",
	"./PaddingBrokenApartIcon.tsx": "CDCu",
	"./PaddingHorizontalIcon.tsx": "vcUR",
	"./PaddingLeftIcon.tsx": "qGks",
	"./PaddingRightIcon.tsx": "kLC5",
	"./PaddingTopIcon.tsx": "c8RN",
	"./PaddingVerticalIcon.tsx": "DtOr",
	"./PaidAdIcon.tsx": "wRi+",
	"./PanHandModeIcon.tsx": "yEkr",
	"./ParagraphIcon.tsx": "Zkhb",
	"./PartialIcon.tsx": "ziyD",
	"./PaymentSubscriptionsIcon.tsx": "BOD6",
	"./PdfFileIcon.tsx": "BWdC",
	"./PersonCheckIcon.tsx": "RW1G",
	"./PersonalizationIcon.tsx": "Qzlo",
	"./PiesyncIcon.tsx": "V8jI",
	"./PinIcon.tsx": "6lUY",
	"./PlayerFastForwardIcon.tsx": "jA8v",
	"./PlayerPauseIcon.tsx": "C0Cx",
	"./PlayerPlayIcon.tsx": "vMEb",
	"./PlayerRewindIcon.tsx": "CFuf",
	"./PopOutIcon.tsx": "G9Vh",
	"./PowerPointFileIcon.tsx": "zigF",
	"./PresentationIcon.tsx": "DDK3",
	"./PreviousIcon.tsx": "lv8p",
	"./ProductBundleIcon.tsx": "aPGZ",
	"./ProductIcon.tsx": "9p1f",
	"./ProspectingIcon.tsx": "NVCD",
	"./PublishIcon.tsx": "Axhw",
	"./PublishingTaskIcon.tsx": "NyS6",
	"./QuestionAnswerIcon.tsx": "6JIb",
	"./QuestionCircleIcon.tsx": "6ape",
	"./QuestionIcon.tsx": "iy12",
	"./QuickbooksIcon.tsx": "HE4A",
	"./QuoteIcon.tsx": "4Akl",
	"./RadioButtonIcon.tsx": "kz0O",
	"./RadioButtonSelectedIcon.tsx": "y3q1",
	"./RatingScaleIcon.tsx": "Lwel",
	"./RatioDataSetFieldIcon.tsx": "itTx",
	"./ReCaptchaIcon.tsx": "k0mV",
	"./ReadMoreIcon.tsx": "q/PU",
	"./ReadOnlyViewIcon.tsx": "cKAR",
	"./RealEstateListingIcon.tsx": "W1Pc",
	"./RecentlySelectedIcon.tsx": "kJ6k",
	"./RecordIcon.tsx": "hbil",
	"./RedoIcon.tsx": "9994",
	"./RefreshIcon.tsx": "lsua",
	"./RegistrationIcon.tsx": "QTOu",
	"./RemoveIcon.tsx": "avZJ",
	"./RemoveTextStyleIcon.tsx": "AN8Q",
	"./ReplaceIcon.tsx": "hSxL",
	"./ReplyAllIcon.tsx": "ItoL",
	"./ReplyForwardArrowIcon.tsx": "Li3t",
	"./ReplyIcon.tsx": "G7Ue",
	"./ReportSpamIcon.tsx": "2X0/",
	"./ReportingAndDataIcon.tsx": "deq8",
	"./ReportingIcon.tsx": "g+kb",
	"./ReportsIcon.tsx": "yG1+",
	"./RequiredPropertyIcon.tsx": "kSlH",
	"./RetractIcon.tsx": "epqJ",
	"./RichTextIcon.tsx": "ukwO",
	"./RightIcon.tsx": "DM/S",
	"./RotateIcon.tsx": "0A1p",
	"./RotateLeadsIcon.tsx": "27Aa",
	"./RowIcon.tsx": "eKId",
	"./SEOIcon.tsx": "gnYR",
	"./SalesIcon.tsx": "iQyl",
	"./SalesQuoteIcon.tsx": "pcQr",
	"./SalesTemplatesIcon.tsx": "hb08",
	"./SaveEditableViewIcon.tsx": "/Lcd",
	"./ScreenCaptureIcon.tsx": "66bS",
	"./SearchIcon.tsx": "PXGv",
	"./SectionHeaderIcon.tsx": "5GBd",
	"./SectionIcon.tsx": "JUXa",
	"./SeekBackward15Icon.tsx": "ro/i",
	"./SeekBackward30Icon.tsx": "vi+m",
	"./SeekForward15Icon.tsx": "4YTt",
	"./SeekForward30Icon.tsx": "oPQj",
	"./SelectModeIcon.tsx": "aGBc",
	"./SendIcon.tsx": "EMsR",
	"./SequencesIcon.tsx": "Wu8C",
	"./ServerlessFunctionIcon.tsx": "VFTg",
	"./ServiceIcon.tsx": "BqZ2",
	"./SettingsIcon.tsx": "M+8+",
	"./ShareIcon.tsx": "WD3I",
	"./SidebarCollapseIcon.tsx": "27eZ",
	"./SidebarExpandIcon.tsx": "0hfZ",
	"./SidebarIcon.tsx": "cssi",
	"./SignalIcon.tsx": "HABk",
	"./SignalPoorIcon.tsx": "QJEr",
	"./SignatureIcon.tsx": "kDNj",
	"./SimpleBotIcon.tsx": "M39J",
	"./SingleLineNumberIcon.tsx": "J5fZ",
	"./SiteTreeIcon.tsx": "Dfhw",
	"./SleepIcon.tsx": "H0nK",
	"./SmsIcon.tsx": "P/zz",
	"./SnoozeIcon.tsx": "gh04",
	"./SocialBlockFacebookIcon.tsx": "22gb",
	"./SocialBlockGoogleplusIcon.tsx": "kB12",
	"./SocialBlockInstagramIcon.tsx": "De8i",
	"./SocialBlockLinkIcon.tsx": "OhhC",
	"./SocialBlockLinkedinIcon.tsx": "+rhK",
	"./SocialBlockPinterestIcon.tsx": "/kjj",
	"./SocialBlockRssIcon.tsx": "b7jQ",
	"./SocialBlockTwitterIcon.tsx": "sX4k",
	"./SocialBlockXIcon.tsx": "r1Tg",
	"./SocialBlockXingIcon.tsx": "M8bl",
	"./SocialBlockYoutubeIcon.tsx": "fXK/",
	"./SocialBlockYoutubeplayIcon.tsx": "r1pJ",
	"./SocialConfluenceIcon.tsx": "HphM",
	"./SocialFacebookIcon.tsx": "jz7d",
	"./SocialFacebookMessengerIcon.tsx": "iT7z",
	"./SocialFacebookWorkplaceIcon.tsx": "Rs3+",
	"./SocialFlickrIcon.tsx": "tJZa",
	"./SocialGithubIcon.tsx": "Sb4C",
	"./SocialGoogleDriveIcon.tsx": "pojl",
	"./SocialGoogleIcon.tsx": "IpO5",
	"./SocialGoogleplusIcon.tsx": "mOU8",
	"./SocialHeartIcon.tsx": "mhOn",
	"./SocialIcon.tsx": "DxF/",
	"./SocialInboundIcon.tsx": "buZ5",
	"./SocialInstagramIcon.tsx": "RU+A",
	"./SocialJiraIcon.tsx": "Yg7p",
	"./SocialLinkedinIcon.tsx": "2htx",
	"./SocialMediumIcon.tsx": "k2ds",
	"./SocialMicrosoftTeamsIcon.tsx": "lB7K",
	"./SocialOneDriveIcon.tsx": "dEgD",
	"./SocialOutlookIcon.tsx": "K0wD",
	"./SocialPinterestIcon.tsx": "j6nz",
	"./SocialPostAgentIcon.tsx": "90fN",
	"./SocialRedditIcon.tsx": "N7Vy",
	"./SocialRetweetIcon.tsx": "iWfU",
	"./SocialRssIcon.tsx": "IE2n",
	"./SocialSharePointIcon.tsx": "MNeb",
	"./SocialSlackIcon.tsx": "lC+h",
	"./SocialSlideshareIcon.tsx": "gX4x",
	"./SocialSoundcloudIcon.tsx": "7C+D",
	"./SocialTiktokIcon.tsx": "gwZF",
	"./SocialTwitterIcon.tsx": "6UDE",
	"./SocialWhatsappIcon.tsx": "5mnA",
	"./SocialXIcon.tsx": "OCdI",
	"./SocialXingIcon.tsx": "W2aU",
	"./SocialYoutubeIcon.tsx": "eqLw",
	"./SocialYoutubeplayIcon.tsx": "m3TD",
	"./SortAlpAscIcon.tsx": "IQ6f",
	"./SortAlpDescIcon.tsx": "1mWy",
	"./SortAmtAscIcon.tsx": "1psi",
	"./SortAmtDescIcon.tsx": "+oSG",
	"./SortNumAscIcon.tsx": "/7SR",
	"./SortNumDescIcon.tsx": "9zW0",
	"./SortTableAscIcon.tsx": "ph3N",
	"./SortTableAscNewIcon.tsx": "ecsF",
	"./SortTableDescIcon.tsx": "8XvA",
	"./SortTableDescNewIcon.tsx": "GCx5",
	"./SortTableIcon.tsx": "SpOC",
	"./SpacerIcon.tsx": "N4Bi",
	"./SpecialCharacterIcon.tsx": "VkFn",
	"./SpellCheckIcon.tsx": "a4T9",
	"./SplitModuleIcon.tsx": "UsXX",
	"./SprocketIcon.tsx": "AlA8",
	"./StarIcon.tsx": "hREr",
	"./StickyNoteIcon.tsx": "wNN3",
	"./StopIcon.tsx": "Oy+J",
	"./StopRecordIcon.tsx": "gvll",
	"./StrikeIcon.tsx": "qjRe",
	"./StylesIcon.tsx": "Btpp",
	"./SubscriptIcon.tsx": "RmYA",
	"./SuccessIcon.tsx": "Iooz",
	"./SunIcon.tsx": "BHJb",
	"./SuperscriptIcon.tsx": "QONd",
	"./SwitchDataSetFieldIcon.tsx": "7VgK",
	"./SwitcherIcon.tsx": "wvCq",
	"./TableIcon.tsx": "r5il",
	"./TabletIcon.tsx": "jHIN",
	"./TagIcon.tsx": "tUDW",
	"./TasksIcon.tsx": "m+Px",
	"./TemporaryChatIcon.tsx": "qS69",
	"./TestIcon.tsx": "yFW0",
	"./TextBodyExpandedIcon.tsx": "Zxu8",
	"./TextColorIcon.tsx": "nTJX",
	"./TextDataTypeIcon.tsx": "3K7b",
	"./TextIcon.tsx": "bI9L",
	"./TextSnippetIcon.tsx": "TwMv",
	"./ThemeFileIcon.tsx": "/U7m",
	"./ThemeIcon.tsx": "X7P5",
	"./ThreeDotsIcon.tsx": "FFGl",
	"./ThumbsDownIcon.tsx": "xp/w",
	"./ThumbsUpIcon.tsx": "FybC",
	"./TicketIcon.tsx": "AA9U",
	"./TimeIcon.tsx": "KETQ",
	"./TranslateIcon.tsx": "NsEd",
	"./TrophyIcon.tsx": "DGpC",
	"./TwoFAFillIcon.tsx": "sVjR",
	"./TwoFAOutlineIcon.tsx": "l6Rx",
	"./UnarchiveIcon.tsx": "x17I",
	"./UnderlineIcon.tsx": "MiBg",
	"./UnderscoreIcon.tsx": "ZpOy",
	"./UndoIcon.tsx": "WGJK",
	"./UnlinkIcon.tsx": "Q+Ap",
	"./UnlockedIcon.tsx": "I90s",
	"./UnpinnedIcon.tsx": "6Ols",
	"./UnpublishIcon.tsx": "p80F",
	"./UnsnoozeIcon.tsx": "j5xM",
	"./UpCaratIcon.tsx": "sejv",
	"./UpIcon.tsx": "EZPM",
	"./UpgradeIcon.tsx": "jxW6",
	"./UploadIcon.tsx": "FevU",
	"./UpvoteFilledIcon.tsx": "japk",
	"./UpvoteIcon.tsx": "CV9C",
	"./UserIcon.tsx": "Yebz",
	"./VerticalMenuIcon.tsx": "v9Wb",
	"./VideoFileIcon.tsx": "L1GM",
	"./VideoIcon.tsx": "soFr",
	"./VideoPlayIcon.tsx": "8Sj+",
	"./VideoPlayerSubtitlesIcon.tsx": "Ff5F",
	"./ViewDetailsIcon.tsx": "h0HO",
	"./ViewIcon.tsx": "ZK+k",
	"./VoiceIcon.tsx": "DNAq",
	"./VolumeDownIcon.tsx": "05B4",
	"./VolumeIcon.tsx": "WYtE",
	"./VolumeMuteIcon.tsx": "Y3y/",
	"./VolumeUpIcon.tsx": "+t7d",
	"./WalletIcon.tsx": "1XdR",
	"./WarningIcon.tsx": "QPpk",
	"./WebContentIcon.tsx": "E7oX",
	"./WebVisitorIcon.tsx": "7z9d",
	"./WebVisitorSegmentsIcon.tsx": "NMlF",
	"./WebsiteIcon.tsx": "qqFE",
	"./WordFileIcon.tsx": "tMeK",
	"./WorkflowsIcon.tsx": "ZJ2N",
	"./WorkspacesIcon.tsx": "VlNU",
	"./XCircleIcon.tsx": "qshi",
	"./XmlFileIcon.tsx": "RAJU",
	"./ZoomInIcon.tsx": "QYJS",
	"./ZoomOutIcon.tsx": "BfBh",
	"./ZoomToFitIcon.tsx": "xkhT"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "JS5i";